// client/src/services/socket.js
import { io } from 'socket.io-client';
import React from 'react';
import { logDev } from '@utils/logDev.js';

const backendUrl = process.env.VITE_BACKEND_URL || window.location.origin;

const baseOptions = {
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
};

// Lobby-Namespace
export const lobbySocket = io(`${backendUrl}/lobby`, baseOptions);
export const LobbySocketContext = React.createContext(lobbySocket);

lobbySocket.once('connect', () =>
    logDev('✅ [lobbySocket] verbunden, ID:', lobbySocket.id)
);
lobbySocket.once('connect_error', err =>
    console.error('❌ [lobbySocket] Verbindungsfehler:', err)
);
lobbySocket.once('disconnect', reason =>
    logDev('⛔️ [lobbySocket] getrennt:', reason)
);

// Game-Namespace (z.B. ?mode=quiz)
const socketCache = {};
export function getGameSocket(mode) {
    if (!mode) {
        throw new Error("getGameSocket() erfordert ein gültiges mode ('quiz' | 'image')");
    }
    logDev('Socket-Mode:', mode);
    if (!socketCache[mode]) {
        const socket = io(`${backendUrl}/game`, {
            ...baseOptions,
            auth: { mode: mode }
        });

        socket.once('connect', () =>
            console.log(`✅ [Socket ${mode}] verbunden:`, socket.id, 'mode:', mode)
        );
        socket.once('connect_error', err =>
            console.error(`❌ [Socket ${mode}] Fehler:`, err)
        );
        socket.once('disconnect', reason =>
            console.warn(`⛔️ [Socket ${mode}] getrennt:`, reason)
        );

        logDev(
            `✅ [Socket ${mode}] Verbunden, ID:`,
            socket.id,
            'mode:',
            mode
        );
        socketCache[mode] = socket;
        logDev('[SocketCache]', socketCache);
    }

    return socketCache[mode];
}

// optional default export für Lobby-Socket
export default lobbySocket;
